import { CarrierBusinessType } from "./CarrierBusinessType";

interface Props {
  isCarrier: boolean;
  businessType: BusinessTypeValue;
  onBusinessTypeChange: (value: BusinessTypeValue) => void;
}

export function CompanyBusinessType(props: Props) {
  const { isCarrier, businessType, onBusinessTypeChange } = props;

  if (isCarrier) {
    return (
      <CarrierBusinessType
        value={businessType}
        onChange={onBusinessTypeChange}
      />
    );
  }

  return null;
}
